import { CSS } from "utils";

const mainPadding = ["$4", "$7", "$9"];
const mainMaxWidth = "1440px";

const mainFullbleedStyle: CSS = {
  marginX: `calc(-1 * ${mainPadding[0]})`,
  "@bp2": { marginX: `calc(-1 * ${mainPadding[1]})` },
  "@bp3": { marginX: `calc(-1 * ${mainPadding[2]})` },
  "@bp4": {
    marginX: `calc(-1 * ${mainPadding[2]} - (100vw - ${mainMaxWidth}) / 2)`,
  },
};

export { mainFullbleedStyle, mainPadding, mainMaxWidth };
